// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"1b9a51aca448eda63445","368":"6158e5695f4ce1e9c9ba","453":"01770093cf1e65d89464","987":"27c29eade793ba8c1c11"}[chunkId] + ".js";
};